<template>
  <div class="container">
    <header class="jumbotron">
      <h1>Deltakere</h1>
      <div>
        ({{content.participants && content.participants.length}} deltakere)
      </div>
    </header>
  <div class="list row">
    <div class="col-md-6">
      <ul class="list-group">
        <li class="list-group-item"
          :class="{ active: index == currentIndex }"
          v-for="(participant, index) in content.participants"
          :key="index"
          @click="setActiveParticipant(participant, index)"
        >
        <div>
          {{ participant.participant_bib }} - {{ participant.participant_name }} <small hidden="hidden">(Id:{{ participant.participant_id }})</small> - {{ participant.participant_team }} 
        <a class="badge badge-success float-right"
          :href="'/mod/competition/'+ currentCompetition_computed +'/participant/' + participant.participant_id"
        > 
          Vis utøver
        </a>
        </div>
        </li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>
import UserService from '../services/user.service';

export default {
  name: 'Participants',
  data() {
    return {
      content: '',
      currentParticipant: null,
      currentIndex: -1,
      debug: false
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var competition_id = this.$route.params.competition_id;
      UserService.getParticipantsBoard(competition_id).then(
        response => {
          this.content = response.data;
        },
        error => {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      );
    },
    setActiveParticipant(participant, index) {
      this.currentParticipant = participant;
      this.currentIndex = index;
    }
  },
  computed: {
    currentCompetition_computed() {
      if ( this.$store
          && this.$store.state
          && this.$store.state.auth ) {
        return this.$store.state.auth.currentCompetition;
      }
      return false;
    },
  }
};
</script>